import {
  ADD_BOOK,
  DELETE_BOOK,
  EDIT_MODE,
  LOADED,
  UPDATE_BOOK,
} from "./actionTypes";

export const loaded = (bookInfo) => {
  return {
    type: LOADED,
    payload: bookInfo,
  };
};

export const addbook = (bookObj) => {
  return {
    type: ADD_BOOK,
    payload: bookObj,
  };
};

export const updatebook = (bookId, updateInfo) => {
  return {
    type: UPDATE_BOOK,
    payload: { bookId, updateInfo },
  };
};

export const createEditmode = (bookInfo, status) => {
  return {
    type: EDIT_MODE,
    payload: {
      bookInfo,
      status,
    },
  };
};

export const deletebook = (bookId) => {
  return {
    type: DELETE_BOOK,
    payload: bookId,
  };
};
